import * as React from 'react'
import './product-price.scss'

interface IProps {
  price: number
  compareAtPrice?: number
  className?: string
}

export const ProductPrice = (props: IProps): JSX.Element => {
  return (
    <div className={`product-price ${props.className || ''}`}>
      <p>
        {`$${props.price.toFixed(2)}`}
        {props.compareAtPrice && <s>{`$${props.compareAtPrice.toFixed(2)}`}</s>}
      </p>
    </div>
  )
}
